import { createAction, props } from '@ngrx/store';

export const twilioTokenLoaded = createAction('[Login Effect] Twilio Token Loaded', props<{ token: string }>());

export const twilioTokenFailedToLoad = createAction('[Login Effect] Twilio Token Failed To Load');

export const twilioChatClientLoaded = createAction('[Login Effect] Twilio Chat Client Loaded');
